import { PetType } from 'constants/pet-type';
import { SegmentationIds } from 'constants/segmentation';
import { SortOptions } from 'constants/collection';

export default {
  'cdp:general:price_from': 'ab',
  'cdp:general:product': 'Produkt',
  'cdp:general:products': '{amount, plural, =0 {# Produkte} one {# Produkt} other {# Produkte}}',
  'cdp:filter:showproducts': 'Produkte anzeigen',
  'cdp:filter:showproduct': 'Produkt anzeigen',
  'cdp:filter:close': 'Schliessen',
  'cdp:filter:foodtypes': 'Futtertypen',
  'cdp:filter:foodtypes:nassfutter': 'Nassfutter',
  'cdp:filter:foodtypes:trockenfutter': 'Trockenfutter',
  'cdp:filter:foodtypes:frische-menus': 'BARF-Menüs',
  'cdp:filter:foodtypes:nahrungserganzung': 'Nahrungsergänzung',
  'cdp:filter:foodtypes:snacks': 'Snacks',
  'cdp:filter:foodtypes:bundles': 'Vorteilspakete',

  'cdp:filter:species': 'Tierart',
  'cdp:filter:species:fur-hunde': 'Hunde',
  'cdp:filter:species:fur-katzen': 'Katzen',

  'cdp:filter:sizes': 'Tiergrösse',
  'cdp:filter:sizes:klein': 'Klein',
  'cdp:filter:sizes:mittel': 'Mittel',
  'cdp:filter:sizes:gross': 'Groß',

  'cdp:filter:sorts': 'Sorten',
  'cdp:filter:sorts:huhn': 'Huhn',
  'cdp:filter:sorts:rind': 'Rind',
  'cdp:filter:sorts:ente': 'Ente',
  'cdp:filter:sorts:pute': 'Pute',
  'cdp:filter:sorts:kalb': 'Kalb',
  'cdp:filter:sorts:wild': 'Wild',
  'cdp:filter:sorts:lachs': 'Lachs',
  'cdp:filter:sorts:pferd': 'Pferd',
  'cdp:filter:sorts:lamm': 'Lamm',
  'cdp:filter:sorts:insekten': 'Insekten',
  'cdp:filter:sorts:veggi': 'Veggi',
  'cdp:filter:sorts:vegan': 'Vegan',
  'cdp:filter:sorts:ziege': 'Ziege',
  'cdp:filter:sorts:thunfisch': 'Thunfisch',
  'cdp:filter:sorts:forelle': 'Forelle',
  'cdp:filter:sorts:kanguru': 'Känguru',
  'cdp:filter:sorts:kaninchen': 'Kaninchen',
  'cdp:filter:sorts:straus': 'Strauß',
  'cdp:filter:sorts:wasserbuffel': 'Wasserbüffel',
  'cdp:filter:sorts:krill': 'Krill',
  'cdp:filter:sorts:sprotten': 'Sprotten',
  'cdp:filter:sorts:hirsch': 'Hirsch',
  'cdp:filter:sorts:geflugel': 'Geflügel',
  'cdp:filter:sorts:truthahn': 'Truthahn',
  'cdp:filter:sorts:fisch': 'Fisch',
  'cdp:filter:sorts:schwein': 'Schwein',
  'cdp:filter:sorts:rind-and-kalb': 'Rind & Kalb',
  'cdp:filter:sorts:vegetarisch-vegan': 'Vegetarisch / Vegan',
  'cdp:filter:sorts:bowls-and-similars': 'Näpfe, Schleckmatte & Tränken',
  'cdp:filter:sorts:toys': 'Spielzeuge',
  'cdp:filter:sorts:walking': 'Gassi gehen',
  'cdp:filter:sorts:sleeping': 'Schlafplätze',
  'cdp:filter:sorts:other-accessories': 'Anderes Zubehör',

  // Used in Personalized Cdp
  'cdp:filter:sorts:duck': 'Ente',
  'cdp:filter:sorts:rabbit': 'Kaninchen',
  'cdp:filter:sorts:game': 'Wild',
  'cdp:filter:sorts:deer': 'Hirsch',
  'cdp:filter:sorts:poultry': 'Geflügel',
  'cdp:filter:sorts:chicken': 'Huhn',
  'cdp:filter:sorts:veal': 'Kalb',
  'cdp:filter:sorts:kangaroo': 'Känguru',
  'cdp:filter:sorts:salmon': 'Lachs',
  'cdp:filter:sorts:turkey': 'Pute',
  'cdp:filter:sorts:beef': 'Rind',
  'cdp:filter:sorts:pork': 'Schwein',
  'cdp:filter:sorts:tuna': 'Thunfisch',
  'cdp:filter:sorts:wild-turkey': 'Truthahn',
  'cdp:filter:sorts:horse': 'Pferd',

  'cdp:filter:desires': 'Besonderheiten',
  'cdp:filter:desires:getreidefrei': 'Getreidefrei',
  'cdp:filter:desires:glutenfrei': 'Glutenfrei',
  'cdp:filter:desires:hypoallergen': 'Hypoallergen',
  'cdp:filter:desires:hypocare': 'Hypo',
  'cdp:filter:desires:leicht-verdaulich': 'Leicht verdaulich',
  'cdp:filter:desires:monoprotein': 'Monoprotein',
  'cdp:filter:desires:zuckerfrei': 'Zuckerfrei',
  'cdp:filter:desires:kalorienreduziert': 'Kalorienreduziert',
  'cdp:filter:desires:low-energy': 'Low Energy',
  'cdp:filter:desires:high-energy': 'High Energy',
  'cdp:filter:desires:spezielle-erkrankungen': 'Spezielle Erkrankungen',

  'cdp:filter:age': 'Alter',
  'cdp:filter:age:adult': 'Adult',
  'cdp:filter:age:senior': 'Senior',
  'cdp:filter:age:welpe': 'Welpe',
  'cdp:filter:age:kitten': 'Kitten',
  'cdp:filter:age:junior': 'Junior',
  'cdp:filter:age:adult-1-6-jahre': 'Adult (1-6 Jahre)',
  'cdp:filter:age:senior-7-jahre': 'Senior (8+ Jahre)',

  'cdp:filter:line': 'Linie',
  'cdp:filter:line:classic': 'Classic',
  'cdp:filter:line:sensitiv': 'Sensitiv',
  'cdp:filter:line:pure-meat': 'Pure Meat',
  'cdp:filter:line:extra-meat': 'Extra Meat',
  'cdp:filter:line:breed-fit': 'Breed Fit',
  'cdp:filter:line:rollen': 'Rollen',
  'cdp:filter:line:denta-snacks': 'Denta Snacks',
  'cdp:filter:line:filet-menu': 'Filet Menü',
  'cdp:filter:line:silkycream': 'Silky Cream',
  'cdp:filter:line:puremeat': 'Pure Meat',
  'cdp:filter:line:meatypate': 'Meaty Pâté',
  'cdp:filter:line:juicyfilets': 'Juicy Filets',
  'cdp:filter:line:green': 'Green',
  'cdp:filter:line:genieser-filets': 'Genießer Filets',
  'cdp:filter:line:superfood': 'Superfood',
  'cdp:filter:line:junior': 'Junior',
  'cdp:filter:line:hypocare': 'Hypocare',
  'cdp:filter:line:feinschmecker-pate': 'Feinschmecker Pate',
  'cdp:filter:line:kaltgepresst': 'Kaltgepresst',
  'cdp:filter:line:mini': 'Mini',
  'cdp:filter:line:limited': 'Limited',
  'cdp:filter:line:softies': 'Softies',
  'cdp:filter:line:happchen': 'Häppchen',
  'cdp:filter:line:pasteten': 'Pasteten',
  'cdp:filter:line:kausnacks': 'Kausnacks ',
  'cdp:filter:line:saucen-menu': 'Saucen Menü',
  'cdp:filter:line:akzeptanz': 'Akzeptanz',
  'cdp:filter:line:creme-snack': 'Creme Snack',
  'cdp:filter:line:soft-snacks': 'Soft Snacks ',
  'cdp:filter:line:filet-snack': 'Filet Snack ',
  'cdp:filter:line:suppe': 'Suppe',
  'cdp:filter:line:vet': 'VET',
  'cdp:filter:line:mousse': 'Mousse',
  'cdp:filter:line:tasties': 'Tasties',
  'cdp:filter:line:soft': 'Soft',
  'cdp:filter:line:cookies': 'Cookies',
  'cdp:filter:line:bundle': 'Probierpakete',
  'cdp:filter:line:knochen-and-kaurollen': 'Knochen & Kaurollen',
  'cdp:filter:line:trainingssnacks': 'Trainingssnacks',
  'cdp:filter:line:zahnpflege': 'Zahnpflege',
  'cdp:filter:line:pasten-and-cremesnacks': 'Pasten & Cremesnacks',
  'cdp:filter:line:hundekekse': 'Hundekekse',
  'cdp:filter:line:kaustreifen-and-sticks': 'Kaustreifen & Sticks',
  'cdp:filter:line:toppers': 'Toppers',
  'cdp:filter:line:gefriergetrocknet': 'Gefriergetrocknet',

  'cdp:filter:funktion': 'Funktion',
  'cdp:filter:funktion:gelenk': 'Gelenk',
  'cdp:filter:funktion:haut-and-fell': 'Haut & Fell',
  'cdp:filter:funktion:zeckensaison': 'Zeckensaison',
  'cdp:filter:funktion:denta': 'Denta',
  'cdp:filter:funktion:entspannung': 'Entspannung',
  'cdp:filter:funktion:leber': 'Leber',
  'cdp:filter:funktion:verdauung': 'Verdauung',
  'cdp:filter:funktion:erkaltung': 'Erkältung',
  'cdp:filter:funktion:digestion': 'Verdauung & Schlingen',
  'cdp:filter:funktion:busy': 'Beschäftigung',
  'cdp:filter:funktion:smart-accessories': 'Intelligenzzubehör',

  'cdp:filter:sort-menu:label:default': 'Nach Relevanz',
  'cdp:filter:sort-menu:label:price-ascending': 'Preis, aufsteigend',
  'cdp:filter:sort-menu:label:price-descending': 'Preis, absteigend',
  'cdp:filter:sort-menu:label:new': 'Neuheiten',
  'cdp:filter:sort-menu:label:best-selling': 'Topseller',
  'cdp:filter:sort-menu:label:title': 'Artikelbezeichnung',
  'cdp:filter:sort-menu:aria-label-select': 'Produkte sortieren',

  'cdp:filter:nutritional-needs': 'Bedürfnis',
  'cdp:filter:nutritional-needs:sehr-wahlerisch': 'Sehr wählerisch',
  'cdp:filter:nutritional-needs:pickyeatercat': 'Sehr wählerisch',
  'cdp:filter:nutritional-needs:digestioncat': 'Verdauungsprobleme',
  'cdp:filter:nutritional-needs:verdauungsprobleme': 'Verdauungsprobleme',
  'cdp:filter:nutritional-needs:unvertraglichkeiten-allergien': 'Unverträglichkeiten / Allergien',
  'cdp:filter:nutritional-needs:haut-and-fellprobleme': 'Haut- & Fellprobleme ',
  'cdp:filter:nutritional-needs:ubergewicht': 'Übergewicht',
  'cdp:filter:nutritional-needs:overweightcat': 'Übergewicht',
  'cdp:filter:nutritional-needs:intolerancecat': 'Allergien / Unverträglichkeiten',
  'cdp:filter:nutritional-needs:hairballcat': 'Haarballen-Hilfe',
  'cdp:filter:nutritional-needs:skinfurcat': 'Haut- und Fellprobleme',
  'cdp:filter:nutritional-needs:immunitycat': 'Immunity+',

  'cdp:filter:health-needs': 'Gesundheitsbedürfnis',
  'cdp:filter:health-needs:gelenk': 'Gelenk',
  'cdp:filter:health-needs:ungeziefer': 'Ungeziefer- und Zeckenschutz',
  'cdp:filter:health-needs:haut-and-fell': 'Haut & Fell',
  'cdp:filter:health-needs:zeckensaison': 'Zeckensaison',
  'cdp:filter:health-needs:denta': 'Denta',
  'cdp:filter:health-needs:entspannung': 'Entspannung',
  'cdp:filter:health-needs:leber': 'Leber',
  'cdp:filter:health-needs:verdauung': 'Verdauung',
  'cdp:filter:health-needs:erkaltung': 'Erkältung',

  'cdp:filter:feed-type': 'Futterart',
  'cdp:filter:feed-type:nassfutter': 'Nassfutter',
  'cdp:filter:feed-type:trockenfutter': 'Trockenfutter',
  'cdp:filter:feed-type:barf': 'BARF',
  'cdp:filter:feed-type:snacks': 'Snacks',

  'cdp:filter:snack-type': 'Snackart',
  'cdp:filter:snack-type:knochen-and-kaurollen': 'Knochen & Kaurollen',
  'cdp:filter:snack-type:trainingssnacks': 'Trainingssnacks',
  'cdp:filter:snack-type:zahnpflege': 'Zahnpflege',
  'cdp:filter:snack-type:pasten-and-cremesnacks': 'Pasten & Cremesnacks',
  'cdp:filter:snack-type:hundekekse': 'Hundekekse',
  'cdp:filter:snack-type:kaustreifen-and-sticks': 'Kaustreifen & Sticks',
  'cdp:filter:snack-type:creme-snack': 'Cremesnacks',
  'cdp:filter:snack-type:filet-snack': 'Filetsnack',
  'cdp:filter:snack-type:suppe': 'Suppen ',
  'cdp:filter:snack-type:soft-snacks': 'Softsnacks',
  'cdp:filter:snack-type:sensitiv': 'Sensitivsnacks',
  'cdp:filter:snack-type:pasten': 'Pasten',
  'cdp:filter:snack-type:toppers': 'Toppers',
  'cdp:filter:snack-type:functional-snacks': 'Functional Snacks',
  'cdp:filter:snack-type:knuspersnacks': 'Knusper Snacks',
  'cdp:filter:snack-type:zahnpflege-and-kausnacks': 'Zahnpflege & Kausnacks',
  'cdp:filter:snack-type:pasten-and-softsnacks': 'Pasten & Softsnacks',

  'cdp:allergy-filter:header': 'Mein Hund verträgt kein...',
  'cdp:allergy-filter:without': 'Ohne',
  'cdp:allergy-filter:rind': 'Rind',
  'cdp:allergy-filter:getreidefrei': 'Getreide',
  'cdp:allergy-filter:huhn': 'Huhn',
  'cdp:allergy-filter:pute': 'Pute',
  'cdp:allergy-filter:ente': 'Ente',
  'cdp:allergy-filter:fisch': 'Fisch',
  'cdp:allergy-filter:kartoffel': 'Kartoffel',
  'cdp:allergy-filter:lamm': 'Lamm',
  'cdp:allergy-filter:pferd': 'Pferd',
  'cdp:allergy-filter:ziege': 'Ziege',
  'cdp:allergy-filter:suskartoffel': 'Süßkartoffel',

  'cdp:productcard:back-soon': 'Ausverkauft',

  'cdp:filter:label': 'Filter',
  'cdp:noproductsfound': 'Keine Produkte gefunden.',
  'cdp:similarproducts': 'Weitere Produkte',
  'cdp:resetfilters': 'Filter zurücksetzen',
  'cdp:reset': 'Zurücksetzen',
  'cdp:toproductbutton': 'Zum Produkt',
  'cdp:showmoreproducts': 'Alle Produkte anzeigen',

  'cdp:configureproduct': 'In den Warenkorb',
  'cdp:sizes': 'Grösse',
  'cdp:packages': 'Einheit',

  'cdp:addtocart': 'In den Warenkorb',
  'cdp:buy-panel:preorder': 'Jetzt vorbestellen',
  'cdp:intervals': 'Intervall',

  'cdp:availableas': 'Erhältlich in',
  'cdp:petsdelifordogs': 'Pets Deli für Hunde',
  'cdp:petsdeliforcats': 'Pets Deli für Katzen',
  'cdp:singlepurchase': 'Einzelkauf',
  'cdp:regulardelivery': 'Regelmäßige Lieferung',
  'cdp:notavailable': 'Derzeit nicht verfügbar',

  'cdp:subscription-intervals:2-weeks': 'Alle 2 Wochen',
  'cdp:subscription-intervals:4-weeks': 'Alle 4 Wochen',
  'cdp:subscription-intervals:6-weeks': 'Alle 6 Wochen',
  'cdp:subscription-intervals:8-weeks': 'Alle 8 Wochen',

  'cdp:findoutmore': 'Jetzt entdecken',

  // Following translations has beend added for an A/B test
  // see https://petsdeli.atlassian.net/browse/PT-3690
  'cdp:filter:special-desires': 'Spezielle Bedürfnisse',
  'cdp:filter:taste': 'Geschmack',
  'cdp:filter:special-desires:fur-welpen': 'Für Welpen & Junghunde',
  'cdp:filter:special-desires:fur-senioren': 'Für Senioren',
  'cdp:filter:special-desires:getreide-glutenfrei': 'Getreide- & glutenfreie Rezeptur',
  'cdp:filter:special-desires:ohne-kartoffeln': 'Ohne Kartoffeln',
  'cdp:filter:special-desires:fur-allergiker': 'Für Allergiker',
  'cdp:filter:special-desires:sensible-verdauung': 'Sensible Verdauung',
  'cdp:filter:special-desires:weniger-kalorien': 'Weniger Kalorien',
  'cdp:filter:special-desires:fur-aktive-hunde': 'Für aktive Hunde',
  'cdp:filter:special-desires:fur-kleine-rassen': 'Für kleine Rassen',

  'cdp:filter:taste:geflugel': 'Geflügel',
  'cdp:filter:taste:rind-kalb': 'Rind & Kalb',
  'cdp:filter:taste:wild': 'Wild',
  'cdp:filter:taste:fisch': 'Fisch',
  'cdp:filter:taste:lamm': 'Lamm',
  'cdp:filter:taste:pferd': 'Pferd',
  'cdp:filter:taste:ziege': 'Ziege',
  'cdp:filter:taste:kanguru': 'Känguru',
  'cdp:filter:taste:insekten': 'Insekten',
  'cdp:filter:taste:vegetarisch-vegan': 'Vegetarisch / Vegan',
  [`cdp:filter:sort:${SortOptions.relevance}`]: 'Beliebtheit',
  [`cdp:filter:sort:${SortOptions.rating}`]: 'Bewertung',
  [`cdp:filter:sort:${SortOptions['price-asc']}`]: 'Niedrigster Preis',
  [`cdp:filter:sort:${SortOptions['price-desc']}`]: 'Höchster Preis',
  [`cdp:filter:sort:${SortOptions.acceptance}`]: 'Beste Akzeptanz',
  [`cdp:filter:sort:${SortOptions.placeholder}`]: 'Sortieren',

  'cdp:nutrition-needs-guidance:description':
    'Individuelle <strong>Bedürfnisse</strong>. Individuelle <strong>Rezepturen</strong>. Wir finden das perfekte Futter für deinen Hund!',
  'cdp:nutrition-needs-guidance:dropwdown:bundle': 'Wähle das Bedürfnis deines Hundes',
  'cdp:nutrition-needs-guidance:dropwdown:pickyeater': 'Mein Hund ist sehr wählerisch',
  'cdp:nutrition-needs-guidance:dropwdown:intolerance': 'Mein Hund hat Unverträglichkeiten',
  'cdp:nutrition-needs-guidance:dropwdown:digestion': 'Mein Hund hat Verdauungsprobleme',
  'cdp:nutrition-needs-guidance:dropwdown:welpe': 'Mein Hund ist ein Welpe',
  'cdp:nutrition-needs-guidance:dropwdown:foodaid': 'Ich möchte beraten werden',
  'cdp:nutrition-needs-guidance:dropwdown:no-help-needed': 'Ich brauche keine Hilfe',

  'cdp:toast:add-single-item': 'Gute Wahl! Dein Probierpaket wurde dem Warenkorb hinzugefügt.',

  'cdp:standalone-cdp:headline': 'Entdecke unsere Vielfalt',
  'cdp:standalone-cdp:subheadline': 'Individuelle Bedürfnisse. Individuelle Rezepturen.',
  'cdp:standalone-cdp:subheadline:segment': 'Mehr Auswahl',
  'cdp:standalone-cdp:load-more': 'Mehr Produkte laden',
  [`cdp:standalone-cdp:headline:${SegmentationIds.DogAdult}`]: 'Für erwachsene Hunde ',
  'cdp:standalone-cdp:headline:intolerance': 'Für Hunde mit Unverträglichkeiten',
  'cdp:standalone-cdp:headline:pickyeater': 'Für wählerische Hunde',
  'cdp:standalone-cdp:headline:digestion': 'Für Hunde mit Verdauungsproblemen',
  'cdp:standalone-cdp:headline:skin-fur': 'Für Hunde mit Haut- & Fellproblemen',
  'cdp:standalone-cdp:headline:overweight': 'Für Hunde mit Übergewicht',
  'cdp:standalone-cdp:headline:prevention': 'Für Hunde, die lange gesund bleiben sollen',
  'cdp:standalone-cdp:headline:welpe': 'Für Welpen',
  'cdp:standalone-cdp:headline:senior': 'Für Senioren',
  'cdp:standalone-cdp:headline:spitz': 'Für Spitze',
  'cdp:standalone-cdp:headline:chihuahua': 'Für Chihuahuas',
  'cdp:standalone-cdp:headline:shepherd-dog': 'Für Schäferhunde',
  'cdp:standalone-cdp:headline:bulldog': 'Für Bulldoggen',
  'cdp:standalone-cdp:headline:terrier': 'Für Terrier',
  'cdp:standalone-cdp:headline:poodle': 'Für Pudel',
  'cdp:standalone-cdp:headline:havanese': 'Für Havaneser & Malteser',
  'cdp:standalone-cdp:headline:dachshund': 'Für Dackel',
  'cdp:standalone-cdp:headline:herdingdog': 'Für Hütehunde',
  'cdp:standalone-cdp:headline:retriever': 'Für Retriever',
  [`cdp:standalone-cdp:headline:${SegmentationIds.MixedLarge}`]: 'Für große Mischlinge',
  [`cdp:standalone-cdp:headline:${SegmentationIds.MixedSmall}`]: 'Für kleine Mischling',
  [`cdp:standalone-cdp:headline:${SegmentationIds.CatPickyEater}`]: 'Für wählerische Katzen',
  [`cdp:standalone-cdp:headline:${SegmentationIds.CatDigestion}`]:
    'Für Katzen mit Verdauungsproblemen',
  [`cdp:standalone-cdp:headline:${SegmentationIds.CatOverweight}`]: 'Für Katzen mit Übergewicht',
  [`cdp:standalone-cdp:headline:${SegmentationIds.Kitten}`]: 'Für Kitten',
  [`cdp:standalone-cdp:headline:${SegmentationIds.IntoleranceCat}`]:
    'Für Katzen mit Unverträglichkeiten',
  [`cdp:standalone-cdp:headline:${SegmentationIds.SkinFurCat}`]:
    'Für Katzen mit Haut- & Fellproblemen',
  [`cdp:standalone-cdp:headline:${SegmentationIds.CatAdult}`]: 'Für erwachsene Katzen',
  [`cdp:standalone-cdp:headline:${SegmentationIds.CatSenior}`]: 'Für Senioren',
  [`cdp:standalone-cdp:headline:${SegmentationIds.HairballHelp}`]:
    'Für Katzen mit Haarballenproblemen',
  'cdp:standalone-cdp:headline:withPetName': 'Mehr Auswahl für {petName}',

  'cdp:tile:badge:save': 'Save {amount}%',

  'cdp:pet-profile:selector:pet-profile-available:title-general-cdp:dog':
    'Auswahl an die Bedürfnisse meines Hundes anpassen?',
  'cdp:pet-profile:selector:pet-profile-available:title-general-cdp:cat':
    'Auswahl an die Bedürfnisse meiner Katze anpassen?',
  'cdp:pet-profile:selector:pet-profile-available:title-with-name':
    'Auswahl an die Bedürfnisse von {petName} anpassen?',

  // Personalization gateway CTA. The pet type is part of the key, the remaining
  // variables are name (pet name) and need (label of the need the CDP represents).
  [`cdp:pet-profile:gateway:${PetType.Dog}:navigate:title`]:
    'Möchtest du Empfehlungen für deinen Hund sehen?',
  [`cdp:pet-profile:gateway:${PetType.Cat}:navigate:title`]:
    'Möchtest du Empfehlungen für deine Katze sehen?',
  'cdp:pet-profile:gateway:navigate:title-with-name': 'Möchtest du Empfehlungen für {name} sehen?',
  [`cdp:pet-profile:gateway:${PetType.Dog}:navigate:text`]:
    'Wir haben Futter und passende Produkte für deinen Hund zusammengestellt, damit du schneller die richtige Auswahl findest.',
  [`cdp:pet-profile:gateway:${PetType.Cat}:navigate:text`]:
    'Wir haben Futter und passende Produkte für deine Katze zusammengestellt, damit du schneller die richtige Auswahl findest.',
  'cdp:pet-profile:gateway:navigate:text-with-name':
    'Wir haben Futter und passende Produkte für {name} zusammengestellt, damit du schneller die richtige Auswahl findest.',
  'cdp:pet-profile:gateway:navigate:cta': 'Empfehlungen ansehen',

  'cdp:pet-profile:gateway:login:cta': 'Anmelden',

  [`cdp:pet-profile:gateway:${PetType.Dog}:update:title`]:
    '{need} – auch für deinen Hund relevant?',
  [`cdp:pet-profile:gateway:${PetType.Cat}:update:title`]:
    '{need} – auch für deine Katze relevant?',
  'cdp:pet-profile:gateway:update:title-with-name': '{need} – auch für {name} relevant?',
  'cdp:pet-profile:gateway:update:text':
    'Wir aktualisieren das Profil, damit du noch passendere Empfehlungen erhältst.',
  'cdp:pet-profile:gateway:update:cta': 'Profil aktualisieren',

  [`cdp:pet-profile:gateway:${PetType.Dog}:create-another:title`]: 'Hast du noch einen Hund?',
  [`cdp:pet-profile:gateway:${PetType.Cat}:create-another:title`]: 'Hast du noch eine Katze?',
  [`cdp:pet-profile:gateway:${PetType.Dog}:create-another:text`]:
    'Erstelle ein weiteres Profil und erhalte passende Empfehlungen für jeden deiner Hunde.',
  [`cdp:pet-profile:gateway:${PetType.Cat}:create-another:text`]:
    'Erstelle ein weiteres Profil und erhalte passende Empfehlungen für jede deiner Katzen.',
  'cdp:pet-profile:gateway:create-another:cta': 'Weiteres Profil erstellen',

  [`cdp:pet-profile:gateway:${PetType.Dog}:create:title`]:
    'Erhalte persönliche Empfehlungen für deinen Hund',
  [`cdp:pet-profile:gateway:${PetType.Cat}:create:title`]:
    'Erhalte persönliche Empfehlungen für deine Katze',
  [`cdp:pet-profile:gateway:${PetType.Dog}:create:text`]:
    'Erstelle ein Profil, damit wir Futter und Produkte empfehlen können, die zu deinem Hund passen.',
  [`cdp:pet-profile:gateway:${PetType.Cat}:create:text`]:
    'Erstelle ein Profil, damit wir Futter und Produkte empfehlen können, die zu deiner Katze passen.',
  'cdp:pet-profile:gateway:create:cta': 'Profil erstellen',

  'cdp:product-card:variant-button:single': '1 Variante anzeigen',
  'cdp:product-card:variant-button:multiple': '{amount} Varianten anzeigen',
  'cdp:product-card:variant-modal:title': 'Produktvariante wählen',
  'cdp:product-card:variant-modal:discount-info': '{couponCode} wurde erfolgreich hinzugefügt',
  'cdp:product-card:variant-modal:product-not-available':
    'Das Produkt ist auf unbestimmte Zeit nicht verfügbar.',

  'cdp:ab-test:product-card:additional-price-info': 'inkl. {percentage}% Abo-Rabatt',
  'cdp:ab-test:product-card:additional-price-info:coupon': ' {couponCode} coupon',
  'cdp:ab-test:product-card:in-cart': 'Im Warenkorb',
};
